import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { UserLeaderboardStats } from '../dto/leaderboard.dto';

@Injectable({
  providedIn: 'root',
})
export class LeaderboardService {
  constructor(
    private backend: BackendService,
    private http: HttpClient
  ) {}

  getUserStats(): Observable<UserLeaderboardStats> {
    return this.backend.get<UserLeaderboardStats>('leaderboard/user-stats');
  }
}

